import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { vehicleGroupSchema } from './schemas/vehicle-group.schema';

export function getMapSetsVehicleGroups(id: number) {
  return fromFetch(
    new Request(`${fleetEnvironment.mapSetsVehicleGroupsUrl(id)}`, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(
    selectData(
      z.object({
        data: z.array(vehicleGroupSchema),
      })
    )
  );
}
